import React, { useState } from 'react';
import { Box, IconButton, InputBase, TextareaAutosize, Typography, Tooltip } from '@mui/material';
import CloseRoundedIcon from '@mui/icons-material/CloseRounded';
import { docGeniusPalette } from 'styles/partials/colors';
import styles from './NotesSideBar.module.css';
import { useAppDispatch } from 'app/hooks';
import {
  selectNoteContent,
  selectNoteTitle,
  updateNoteContent,
  updateNoteTitle,
} from 'features/document/documentSlice';
import { connect } from 'react-redux';
import { RootState } from 'app/store';

interface NotesSideBarProps {
  isViewMode?: boolean;
  handleClose: () => void;
}

type MapProps = ReturnType<typeof mapState>;

type Props = MapProps & NotesSideBarProps;

const NotesSideBar: React.FC<Props> = ({ handleClose, noteContent, noteTitle, isViewMode }) => {
  const dispatch = useAppDispatch();
  const [title, setTitle] = useState<string>(noteTitle);
  const [content, setContent] = useState<string>(noteContent);

  const handleSaveTitle = (e: React.FocusEvent<HTMLTextAreaElement | HTMLInputElement, Element>) => {
    const title = e.target.value.trim();
    if (title !== noteTitle) {
      dispatch(updateNoteTitle(title));
    }
  };
  const handleSaveContent = (e: React.FocusEvent<HTMLTextAreaElement | HTMLInputElement, Element>) => {
    const content = e.target.value.trim();
    if (content !== noteContent) {
      dispatch(updateNoteContent(content));
    }
  };

  return (
    <Box className={styles.notesSidebar}>
      <Box className={styles.notesHeader}>
        <Typography className={`${styles.notesText} ${styles.headerText}`}>
          Notes - {isViewMode && `${title}`}
        </Typography>
        {!isViewMode && (
          <InputBase
            className={styles.notesTitle}
            placeholder='Notes'
            onChange={e => {
              setTitle(e.target.value);
            }}
            onBlur={handleSaveTitle}
            value={title}
          />
        )}

        <Tooltip title='Close' arrow>
          <IconButton disableTouchRipple onClick={handleClose}>
            <CloseRoundedIcon sx={{ color: docGeniusPalette.primaryBlue }} />
          </IconButton>
        </Tooltip>
      </Box>
      {isViewMode ? (
        <p className={styles.notesTextReadOnly}>{content}</p>
      ) : (
        <TextareaAutosize
          className={`${styles.notesText} ${styles.notesContent}`}
          placeholder='Start writing your notes here'
          onBlur={handleSaveContent}
          onChange={e => {
            setContent(e.target.value);
          }}
          value={content}
        />
      )}
    </Box>
  );
};

const mapState = (
  state: RootState
): {
  noteContent: string;
  noteTitle: string;
} => ({
  noteContent: selectNoteContent(state),
  noteTitle: selectNoteTitle(state),
});

export default connect(mapState)(NotesSideBar);
